import './style.scss';
function ResultsCount (props) {
  const {
    first,
    last,
    total,
    preFilterTotal
  } = props;

  return (
    <div className="results-count">
      Showing {first} to {last} of {total} entries {preFilterTotal && `(filtered from ${preFilterTotal} total entries)`}
    </div>
  );
}

export default ResultsCount;